import { render, staticRenderFns } from "./DomainAdd.vue?vue&type=template&id=472f3922&scoped=true&"
import script from "./DomainAdd.vue?vue&type=script&lang=js&"
export * from "./DomainAdd.vue?vue&type=script&lang=js&"
import style0 from "./DomainAdd.vue?vue&type=style&index=0&id=472f3922&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472f3922",
  null
  
)

export default component.exports